<script type="ts">

  import type { Dropdown } from "../lib/interfaces";
  import { __ } from "@wordpress/i18n";

  import {
    selectedDropdown,
    selectedAudience,
    selectedSolution,
    selectedChildIndustry,
  } from "../stores";

  import instance from "../axios";
  import DropdownOne from "./DropdownOne.svelte";
  import DropdownTwo from "./DropdownTwo.svelte";
  import DropdownThree from "./DropdownThree.svelte";

  let current : Number = 0;

  $: fetchDropdown = async (): Promise<any> => {
    try {
        const response = await instance.get(`/sb/get-dropdown`, {
          params: {
            "id": `${$selectedDropdown}`,
            "acf_format": "standard"
          },
        });
        let data: Dropdown = response.data.dropdown.acf;
        return data;
    } catch (e) {
      return false;
    }
  }

  function resetDropdown() {
    const actives = document.querySelectorAll('.menu__dropdown-toggle.active');
    actives.forEach(active => {
      active.classList.remove('active');
    });
    $selectedDropdown = '';
    $selectedSolution = '';
    $selectedChildIndustry = '';
    $selectedAudience = '';
  }

</script>

{#await fetchDropdown() then dropdown}
  {#if dropdown}

  <nav class="dropdown" class:dropdown--no-pad={dropdown.template === '2'} class:dropdown--large={dropdown.template === '3'}>
    <div class="dropdown__mobile-nav">
      <button on:click={resetDropdown} class="dropdown__button">{ __('Menu', '_SBF')}</button>
    </div>
    <div class="dropdown__wrapper">
      {#if dropdown.template === '1'}
        <DropdownOne {dropdown}></DropdownOne>
      {/if}

      {#if dropdown.template === '2'}
        <DropdownTwo {dropdown}></DropdownTwo>
      {/if}

      {#if dropdown.template === '3'}
        <DropdownThree {dropdown}></DropdownThree>
      {/if}
    </div>
  </nav>

  {/if}
{/await}
